import { createQueryHook } from '@hooks/createQueryHook'

// Player freebets. Component passes { status, page, pageSize }.
// Returns render-ready { rows, activeCount, page, pageSize }.
export const useFreebets = createQueryHook('freebets.list')

// Active freebets count. Component passes { status }.
export const useFreebetsCount = createQueryHook('freebets.count')
